import { Skeleton } from '@picsart/design-system/components/Skeleton';
import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';

import useDevice from 'hooks/useDeviceType';

import useStyles from './styles';
import { TemplatesCategoryCarouselProps } from './types';

const FallBack = ({ titleSection, descriptionSection }: TemplatesCategoryCarouselProps) => {
  const classes = useStyles();
  const { isMobile } = useDevice();
  const LENGTH = isMobile ? 2 : 8;

  return (
    <HorizontalContainer dataTestId="falback-wrapper">
      <div className={classes.root}>
        {titleSection && (
          <div className={classes.titleWrapper} data-testid="title">
            <Skeleton className={classes.skeletonTitle} />
          </div>
        )}

        {descriptionSection && (
          <div className={classes.descriptionWrapper} data-testid="description">
            <Skeleton className={classes.skeletonDescription} />
          </div>
        )}

        <div className={classes.carouselWrapper}>
          <div className={classes.skeletonCarouselWrapper} data-testid="carousel">
            {Array.from({ length: LENGTH }).map((_, index) => (
              <Skeleton key={index} className={classes.skeletonCarousel} />
            ))}
          </div>
        </div>

        <Skeleton className={classes.skeletonButton} data-testid="button" />
      </div>
    </HorizontalContainer>
  );
};

export default FallBack;
